module.exports = __webpack_public_path__ + "img/icon_red_ky.6531873f.png";